import { jsx as vr } from "react/jsx-runtime";
import { c as Ws } from "react/compiler-runtime";
import ne, { createContext as Ns } from "react";
import { enableES5 as Rs } from "immer";
import Fs from "react-markdown";
import Cs from "remark-gfm";
import Is from "rehype-raw";
import { renderToString as Es } from "react-dom/server";
import { useSpeechToText as Ls } from "../utilities/sound/speechToText.js";
import { useTextToSpeak as As } from "../utilities/sound/textToSpeech.js";
var Fr = /* @__PURE__ */ (function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, n) {
      s.__proto__ = n;
    } || function(s, n) {
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (s[a] = n[a]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function s() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (s.prototype = r.prototype, new s());
  };
})(), Us = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, s, n, a, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (s) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (s = 1, n && (a = u[0] & 2 ? n.return : u[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, u[1])).done) return a;
      switch (n = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, n = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = u;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(u);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (f) {
      u = [6, f], n = 0;
    } finally {
      s = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, mt = function(e, t) {
  for (var r = 0, s = t.length, n = e.length; r < s; r++, n++)
    e[n] = t[r];
  return e;
}, Hs = Object.defineProperty, Vs = Object.defineProperties, js = Object.getOwnPropertyDescriptors, kr = Object.getOwnPropertySymbols, Gs = Object.prototype.hasOwnProperty, zs = Object.prototype.propertyIsEnumerable, Sr = function(e, t, r) {
  return t in e ? Hs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, Ge = function(e, t) {
  for (var r in t || (t = {}))
    Gs.call(t, r) && Sr(e, r, t[r]);
  if (kr)
    for (var s = 0, n = kr(t); s < n.length; s++) {
      var r = n[s];
      zs.call(t, r) && Sr(e, r, t[r]);
    }
  return e;
}, Rt = function(e, t) {
  return Vs(e, js(t));
}, $s = function(e, t, r) {
  return new Promise(function(s, n) {
    var a = function(c) {
      try {
        o(r.next(c));
      } catch (u) {
        n(u);
      }
    }, i = function(c) {
      try {
        o(r.throw(c));
      } catch (u) {
        n(u);
      }
    }, o = function(c) {
      return c.done ? s(c.value) : Promise.resolve(c.value).then(a, i);
    };
    o((r = r.apply(e, t)).next());
  });
};
function We(e, t) {
  function r() {
    for (var s = [], n = 0; n < arguments.length; n++)
      s[n] = arguments[n];
    if (t) {
      var a = t.apply(void 0, s);
      if (!a)
        throw new Error("prepareAction did not return an object");
      return Ge(Ge({
        type: e,
        payload: a.payload
      }, "meta" in a && { meta: a.meta }), "error" in a && { error: a.error });
    }
    return { type: e, payload: s[0] };
  }
  return r.toString = function() {
    return "" + e;
  }, r.type = e, r.match = function(s) {
    return s.type === e;
  }, r;
}
(function(e) {
  Fr(t, e);
  function t() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    var n = e.apply(this, r) || this;
    return Object.setPrototypeOf(n, t.prototype), n;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return e.prototype.concat.apply(this, r);
  }, t.prototype.prepend = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, mt([void 0], r[0].concat(this))))() : new (t.bind.apply(t, mt([void 0], r.concat(this))))();
  }, t;
})(Array);
(function(e) {
  Fr(t, e);
  function t() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    var n = e.apply(this, r) || this;
    return Object.setPrototypeOf(n, t.prototype), n;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return e.prototype.concat.apply(this, r);
  }, t.prototype.prepend = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, mt([void 0], r[0].concat(this))))() : new (t.bind.apply(t, mt([void 0], r.concat(this))))();
  }, t;
})(Array);
process.env.NODE_ENV;
process.env.NODE_ENV;
var Zs = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", At = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", r = e; r--; )
    t += Zs[Math.random() * 64 | 0];
  return t;
}, qs = [
  "name",
  "message",
  "stack",
  "code"
], Ft = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), Mr = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), Bs = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, r = 0, s = qs; r < s.length; r++) {
      var n = s[r];
      typeof e[n] == "string" && (t[n] = e[n]);
    }
    return t;
  }
  return { message: String(e) };
};
(function() {
  function e(t, r, s) {
    var n = We(t + "/fulfilled", function(f, D, v, U) {
      return {
        payload: f,
        meta: Rt(Ge({}, U || {}), {
          arg: v,
          requestId: D,
          requestStatus: "fulfilled"
        })
      };
    }), a = We(t + "/pending", function(f, D, v) {
      return {
        payload: void 0,
        meta: Rt(Ge({}, v || {}), {
          arg: D,
          requestId: f,
          requestStatus: "pending"
        })
      };
    }), i = We(t + "/rejected", function(f, D, v, U, R) {
      return {
        payload: U,
        error: (s && s.serializeError || Bs)(f || "Rejected"),
        meta: Rt(Ge({}, R || {}), {
          arg: v,
          requestId: D,
          rejectedWithValue: !!U,
          requestStatus: "rejected",
          aborted: f?.name === "AbortError",
          condition: f?.name === "ConditionError"
        })
      };
    }), o = !1, c = typeof AbortController < "u" ? AbortController : (
      /** @class */
      (function() {
        function f() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return f.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (o || (o = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, f;
      })()
    );
    function u(f) {
      return function(D, v, U) {
        var R = s?.idGenerator ? s.idGenerator(f) : At(), _e = new c(), Oe;
        function Ke(we) {
          Oe = we, _e.abort();
        }
        var Ye = (function() {
          return $s(this, null, function() {
            var we, be, x, H, ge, re, pe;
            return Us(this, function(q) {
              switch (q.label) {
                case 0:
                  return q.trys.push([0, 4, , 5]), H = (we = s?.condition) == null ? void 0 : we.call(s, f, { getState: v, extra: U }), Qs(H) ? [4, H] : [3, 2];
                case 1:
                  H = q.sent(), q.label = 2;
                case 2:
                  if (H === !1 || _e.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return ge = new Promise(function(W, se) {
                    return _e.signal.addEventListener("abort", function() {
                      return se({
                        name: "AbortError",
                        message: Oe || "Aborted"
                      });
                    });
                  }), D(a(R, f, (be = s?.getPendingMeta) == null ? void 0 : be.call(s, { requestId: R, arg: f }, { getState: v, extra: U }))), [4, Promise.race([
                    ge,
                    Promise.resolve(r(f, {
                      dispatch: D,
                      getState: v,
                      extra: U,
                      requestId: R,
                      signal: _e.signal,
                      abort: Ke,
                      rejectWithValue: function(W, se) {
                        return new Ft(W, se);
                      },
                      fulfillWithValue: function(W, se) {
                        return new Mr(W, se);
                      }
                    })).then(function(W) {
                      if (W instanceof Ft)
                        throw W;
                      return W instanceof Mr ? n(W.payload, R, f, W.meta) : n(W, R, f);
                    })
                  ])];
                case 3:
                  return x = q.sent(), [3, 5];
                case 4:
                  return re = q.sent(), x = re instanceof Ft ? i(null, R, f, re.payload, re.meta) : i(re, R, f), [3, 5];
                case 5:
                  return pe = s && !s.dispatchConditionRejection && i.match(x) && x.meta.condition, pe || D(x), [2, x];
              }
            });
          });
        })();
        return Object.assign(Ye, {
          abort: Ke,
          requestId: R,
          arg: f,
          unwrap: function() {
            return Ye.then(Js);
          }
        });
      };
    }
    return Object.assign(u, {
      pending: a,
      rejected: i,
      fulfilled: n,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function Js(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Qs(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var qt = "listenerMiddleware";
We(qt + "/add");
We(qt + "/removeAll");
We(qt + "/remove");
var Dr;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
Rs();
var Cr;
function d() {
  return Cr.apply(null, arguments);
}
function Ks(e) {
  Cr = e;
}
function J(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Se(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function w(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Bt(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (w(e, t))
      return !1;
  return !0;
}
function C(e) {
  return e === void 0;
}
function de(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function qe(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Ir(e, t) {
  var r = [], s, n = e.length;
  for (s = 0; s < n; ++s)
    r.push(t(e[s], s));
  return r;
}
function X(e, t) {
  for (var r in t)
    w(t, r) && (e[r] = t[r]);
  return w(t, "toString") && (e.toString = t.toString), w(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function ee(e, t, r, s) {
  return os(e, t, r, s, !0).utc();
}
function Xs() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidOffset: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function y(e) {
  return e._pf == null && (e._pf = Xs()), e._pf;
}
var Ut;
Array.prototype.some ? Ut = Array.prototype.some : Ut = function(e) {
  var t = Object(this), r = t.length >>> 0, s;
  for (s = 0; s < r; s++)
    if (s in t && e.call(this, t[s], s, t))
      return !0;
  return !1;
};
function Jt(e) {
  var t = null, r = !1, s = e._d && !isNaN(e._d.getTime());
  if (s && (t = y(e), r = Ut.call(t.parsedDateParts, function(n) {
    return n != null;
  }), s = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidOffset && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (s = s && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = s;
  else
    return s;
  return e._isValid;
}
function Be(e) {
  var t = ee(NaN);
  return e != null ? X(y(t), e) : y(t).userInvalidated = !0, t;
}
var Or = d.momentProperties = [], Ct = !1;
function Qt(e, t) {
  var r, s, n, a = Or.length;
  if (C(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), C(t._i) || (e._i = t._i), C(t._f) || (e._f = t._f), C(t._l) || (e._l = t._l), C(t._strict) || (e._strict = t._strict), C(t._tzm) || (e._tzm = t._tzm), C(t._isUTC) || (e._isUTC = t._isUTC), C(t._offset) || (e._offset = t._offset), C(t._pf) || (e._pf = y(t)), C(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      s = Or[r], n = t[s], C(n) || (e[s] = n);
  return e;
}
function Je(e) {
  Qt(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Ct === !1 && (Ct = !0, d.updateOffset(this), Ct = !1);
}
function L(e) {
  return e instanceof Je || e != null && e._isAMomentObject != null;
}
function Er(e) {
  d.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function $(e, t) {
  var r = !0;
  return X(function() {
    if (d.deprecationHandler != null && d.deprecationHandler(null, e), r) {
      var s = [], n, a, i, o = arguments.length;
      for (a = 0; a < o; a++) {
        if (n = "", typeof arguments[a] == "object") {
          n += `
[` + a + "] ";
          for (i in arguments[0])
            w(arguments[0], i) && (n += i + ": " + arguments[0][i] + ", ");
          n = n.slice(0, -2);
        } else
          n = arguments[a];
        s.push(n);
      }
      Er(
        e + `
Arguments: ` + Array.prototype.slice.call(s).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Yr = {};
function Lr(e, t) {
  d.deprecationHandler != null && d.deprecationHandler(e, t), Yr[e] || (Er(t + `
` + new Error().stack), Yr[e] = !0);
}
d.suppressDeprecationWarnings = !1;
d.deprecationHandler = null;
function te(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
var br = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function Z(e) {
  return typeof e == "string" ? br[e] || br[e.toLowerCase()] : void 0;
}
function Kt(e) {
  var t = {}, r, s;
  for (s in e)
    w(e, s) && (r = Z(s), r && (t[r] = e[s]));
  return t;
}
var en = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function tn(e) {
  var t = [], r;
  for (r in e)
    w(e, r) && t.push({ unit: r, priority: en[r] });
  return t.sort(function(s, n) {
    return s.priority - n.priority;
  }), t;
}
function z(e, t, r) {
  var s = "" + Math.abs(e), n = t - s.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + s;
}
var Xt = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ut = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, It = {}, Ne = {};
function m(e, t, r, s) {
  var n = s;
  typeof s == "string" && (n = function() {
    return this[s]();
  }), e && (Ne[e] = n), t && (Ne[t[0]] = function() {
    return z(n.apply(this, arguments), t[1], t[2]);
  }), r && (Ne[r] = function() {
    return this.localeData().ordinal(
      n.apply(this, arguments),
      e
    );
  });
}
function rn(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function sn(e) {
  var t = e.match(Xt), r, s;
  for (r = 0, s = t.length; r < s; r++)
    Ne[t[r]] ? t[r] = Ne[t[r]] : t[r] = rn(t[r]);
  return function(n) {
    var a = "", i;
    for (i = 0; i < s; i++)
      a += te(t[i]) ? t[i].call(n, e) : t[i];
    return a;
  };
}
function ft(e, t) {
  if (!e.isValid())
    return e.localeData().invalidDate();
  t = Ar(t, e.localeData());
  var r = "$" + t;
  return w(It, r) || (It[r] = sn(t)), It[r](e);
}
function Ar(e, t) {
  var r = 5;
  function s(n) {
    return t.longDateFormat(n) || n;
  }
  for (ut.lastIndex = 0; r >= 0 && ut.test(e); )
    e = e.replace(
      ut,
      s
    ), ut.lastIndex = 0, r -= 1;
  return e;
}
var Ur = /\d/, A = /\d\d/, Hr = /\d{3}/, er = /\d{4}/, vt = /[+-]?\d{6}/, M = /\d\d?/, Vr = /\d\d\d\d?/, tr = /\d\d\d\d\d\d?/, kt = /\d{1,3}/, rr = /\d{1,4}/, St = /[+-]?\d{1,6}/, Ce = /\d+/, Mt = /[+-]?\d+/, nn = /Z|[+-]\d\d:?\d\d/gi, Dt = /Z|[+-]\d\d(?::?\d\d)?/gi, an = /[+-]?\d+(\.\d{1,3})?/, Qe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Ie = /^[1-9]\d?/, sr = /^([1-9]\d|\d)/, yt;
yt = {};
function h(e, t, r) {
  yt[e] = te(t) ? t : function(s, n) {
    return s && r ? r : t;
  };
}
function on(e, t) {
  return w(yt, e) ? yt[e](t._strict, t._locale) : new RegExp(ln(e));
}
function ln(e) {
  return le(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, s, n, a) {
        return r || s || n || a;
      }
    )
  );
}
function le(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function j(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function _(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = j(t)), r;
}
var Ht = {};
function S(e, t) {
  var r, s = t, n;
  for (typeof e == "string" && (e = [e]), de(t) && (s = function(a, i) {
    i[t] = _(a);
  }), n = e.length, r = 0; r < n; r++)
    Ht[e[r]] = s;
}
function Ee(e, t) {
  S(e, function(r, s, n, a) {
    n._w = n._w || {}, t(r, n._w, n, a);
  });
}
function un(e, t, r) {
  t != null && w(Ht, e) && Ht[e](t, r._a, r, e);
}
function Ot(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var b = 0, E = 1, I = 2, T = 3, G = 4, oe = 5, ke = 6, dn = 7, fn = 8;
m("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? z(e, 4) : "+" + e;
});
m(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
m(0, ["YYYY", 4], 0, "year");
m(0, ["YYYYY", 5], 0, "year");
m(0, ["YYYYYY", 6, !0], 0, "year");
h("Y", Mt);
h("YY", M, A);
h("YYYY", rr, er);
h("YYYYY", St, vt);
h("YYYYYY", St, vt);
S(["YYYYY", "YYYYYY"], b);
S("YYYY", function(e, t) {
  t[b] = e.length === 2 ? d.parseTwoDigitYear(e) : _(e);
});
S("YY", function(e, t) {
  t[b] = d.parseTwoDigitYear(e);
});
S("Y", function(e, t) {
  t[b] = parseInt(e, 10);
});
function ze(e) {
  return Ot(e) ? 366 : 365;
}
d.parseTwoDigitYear = function(e) {
  return _(e) + (_(e) > 68 ? 1900 : 2e3);
};
var jr = Le("FullYear", !0);
function hn() {
  return Ot(this.year());
}
function Le(e, t) {
  return function(r) {
    return r != null ? (Gr(this, e, r), d.updateOffset(this, t), this) : $e(this, e);
  };
}
function $e(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, s = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return s ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return s ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return s ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return s ? r.getUTCHours() : r.getHours();
    case "Date":
      return s ? r.getUTCDate() : r.getDate();
    case "Day":
      return s ? r.getUTCDay() : r.getDay();
    case "Month":
      return s ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return s ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function Gr(e, t, r) {
  var s, n, a, i, o;
  if (!(!e.isValid() || isNaN(r))) {
    switch (s = e._d, n = e._isUTC, t) {
      case "Milliseconds":
        return void (n ? s.setUTCMilliseconds(r) : s.setMilliseconds(r));
      case "Seconds":
        return void (n ? s.setUTCSeconds(r) : s.setSeconds(r));
      case "Minutes":
        return void (n ? s.setUTCMinutes(r) : s.setMinutes(r));
      case "Hours":
        return void (n ? s.setUTCHours(r) : s.setHours(r));
      case "Date":
        return void (n ? s.setUTCDate(r) : s.setDate(r));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    a = r, i = e.month(), o = e.date(), o = o === 29 && i === 1 && !Ot(a) ? 28 : o, n ? s.setUTCFullYear(a, i, o) : s.setFullYear(a, i, o);
  }
}
function cn(e) {
  return e = Z(e), te(this[e]) ? this[e]() : this;
}
function mn(e, t) {
  if (typeof e == "object") {
    e = Kt(e);
    var r = tn(e), s, n = r.length;
    for (s = 0; s < n; s++)
      this[r[s].unit](e[r[s].unit]);
  } else if (e = Z(e), te(this[e]))
    return this[e](t);
  return this;
}
function yn(e, t) {
  return (e % t + t) % t;
}
var Y;
Array.prototype.indexOf ? Y = Array.prototype.indexOf : Y = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function nr(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = yn(t, 12);
  return e += (t - r) / 12, r === 1 ? Ot(e) ? 29 : 28 : 31 - r % 7 % 2;
}
m("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
m("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
m("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
h("M", M, Ie);
h("MM", M, A);
h("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
h("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
S(["M", "MM"], function(e, t) {
  t[E] = _(e) - 1;
});
S(["MMM", "MMMM"], function(e, t, r, s) {
  var n = r._locale.monthsParse(e, s, r._strict);
  n != null ? t[E] = n : y(r).invalidMonth = e;
});
var _n = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), zr = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), $r = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, wn = Qe, gn = Qe, Tr = [
  "monthsParse",
  "longMonthsParse",
  "shortMonthsParse",
  "monthsRegex",
  "monthsShortRegex",
  "monthsStrictRegex",
  "monthsShortStrictRegex"
];
function pn(e, t) {
  var r, s;
  for (r = 0; r < Tr.length; r++)
    s = Tr[r], w(t, s) || delete e["_" + s];
}
function vn(e, t) {
  return e ? J(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || $r).test(t) ? "format" : "standalone"][e.month()] : J(this._months) ? this._months : this._months.standalone;
}
function kn(e, t) {
  return e ? J(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[$r.test(t) ? "format" : "standalone"][e.month()] : J(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Sn(e, t, r) {
  var s, n, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s)
      a = ee([2e3, s]), this._shortMonthsParse[s] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[s] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (n = Y.call(this._shortMonthsParse, i), n !== -1 ? n : null) : (n = Y.call(this._longMonthsParse, i), n !== -1 ? n : null) : t === "MMM" ? (n = Y.call(this._shortMonthsParse, i), n !== -1 ? n : (n = Y.call(this._longMonthsParse, i), n !== -1 ? n : null)) : (n = Y.call(this._longMonthsParse, i), n !== -1 ? n : (n = Y.call(this._shortMonthsParse, i), n !== -1 ? n : null));
}
function Mn(e, t, r) {
  var s, n, a;
  if (this._monthsParseExact)
    return Sn.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++) {
    if (n = ee([2e3, s]), r && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp(
      "^" + this.months(n, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[s] = new RegExp(
      "^" + this.monthsShort(n, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[s] && (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[s] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[s].test(e))
      return s;
    if (r && t === "MMM" && this._shortMonthsParse[s].test(e))
      return s;
    if (!r && this._monthsParse[s].test(e))
      return s;
  }
}
function Zr(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = _(t);
    else if (t = e.localeData().monthsParse(t), !de(t))
      return e;
  }
  var r = t, s = e.date();
  return s = s < 29 ? s : Math.min(s, nr(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, s) : e._d.setMonth(r, s), e;
}
function qr(e) {
  return e != null ? (Zr(this, e), d.updateOffset(this, !0), this) : $e(this, "Month");
}
function Dn() {
  return nr(this.year(), this.month());
}
function On(e) {
  return this._monthsParseExact ? (w(this, "_monthsRegex") || Br.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (w(this, "_monthsShortRegex") || (this._monthsShortRegex = wn), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Yn(e) {
  return this._monthsParseExact ? (w(this, "_monthsRegex") || Br.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (w(this, "_monthsRegex") || (this._monthsRegex = gn), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Br() {
  function e(c, u) {
    return u.length - c.length;
  }
  var t = [], r = [], s = [], n, a, i, o;
  for (n = 0; n < 12; n++)
    a = ee([2e3, n]), i = le(this.monthsShort(a, "")), o = le(this.months(a, "")), t.push(i), r.push(o), s.push(o), s.push(i);
  t.sort(e), r.sort(e), s.sort(e), this._monthsRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
m("d", 0, "do", "day");
m("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
m("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
m("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
m("e", 0, 0, "weekday");
m("E", 0, 0, "isoWeekday");
m("eHHmm", 0, 0, function() {
  return "" + this.weekday() + z(this.hours(), 2) + z(this.minutes(), 2);
});
h("d", M);
h("e", M);
h("E", M);
h("eHHmm", tr);
h("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
h("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
h("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Ee(["dd", "ddd", "dddd"], function(e, t, r, s) {
  var n = r._locale.weekdaysParse(e, s, r._strict);
  n != null ? t.d = n : y(r).invalidWeekday = e;
});
Ee(["d", "e", "E"], function(e, t, r, s) {
  t[s] = _(e);
});
Ee("eHHmm", function(e, t, r) {
  var s = e.length - 4;
  t.e = _(e.substr(0, s)), r._a[T] = _(e.substr(s, 2)), r._a[G] = _(e.substr(s + 2));
});
function bn(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Tn(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function ar(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Pn = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Jr = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), xn = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Wn = Qe, Nn = Qe, Rn = Qe, Pr = [
  "weekdaysParse",
  "fullWeekdaysParse",
  "shortWeekdaysParse",
  "minWeekdaysParse",
  "weekdaysRegex",
  "weekdaysShortRegex",
  "weekdaysMinRegex",
  "weekdaysStrictRegex",
  "weekdaysShortStrictRegex",
  "weekdaysMinStrictRegex"
];
function Fn(e, t) {
  var r, s;
  for (r = 0; r < Pr.length; r++)
    s = Pr[r], w(t, s) || delete e["_" + s];
}
function Cn(e, t) {
  var r = J(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? ar(r, this._week.dow) : e ? r[e.day()] : r;
}
function In(e) {
  return e === !0 ? ar(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function En(e) {
  return e === !0 ? ar(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Ln(e, t, r) {
  var s, n, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s)
      a = ee([2e3, 1]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (n = Y.call(this._weekdaysParse, i), n !== -1 ? n : null) : t === "ddd" ? (n = Y.call(this._shortWeekdaysParse, i), n !== -1 ? n : null) : (n = Y.call(this._minWeekdaysParse, i), n !== -1 ? n : null) : t === "dddd" ? (n = Y.call(this._weekdaysParse, i), n !== -1 || (n = Y.call(this._shortWeekdaysParse, i), n !== -1) ? n : (n = Y.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : t === "ddd" ? (n = Y.call(this._shortWeekdaysParse, i), n !== -1 || (n = Y.call(this._weekdaysParse, i), n !== -1) ? n : (n = Y.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : (n = Y.call(this._minWeekdaysParse, i), n !== -1 || (n = Y.call(this._weekdaysParse, i), n !== -1) ? n : (n = Y.call(this._shortWeekdaysParse, i), n !== -1 ? n : null));
}
function An(e, t, r) {
  var s, n, a;
  if (this._weekdaysParseExact)
    return Ln.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++) {
    if (n = ee([2e3, 1]).day(s), r && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp(
      "^" + this.weekdays(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[s] = new RegExp(
      "^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[s] = new RegExp(
      "^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[s] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[s] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[s].test(e))
      return s;
    if (r && t === "ddd" && this._shortWeekdaysParse[s].test(e))
      return s;
    if (r && t === "dd" && this._minWeekdaysParse[s].test(e))
      return s;
    if (!r && this._weekdaysParse[s].test(e))
      return s;
  }
}
function Un(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = $e(this, "Day");
  return e != null ? (e = bn(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Hn(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Vn(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Tn(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function jn(e) {
  return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || ir.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (w(this, "_weekdaysRegex") || (this._weekdaysRegex = Wn), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Gn(e) {
  return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || ir.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (w(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Nn), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function zn(e) {
  return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || ir.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (w(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Rn), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function ir() {
  function e(f, D) {
    return D.length - f.length;
  }
  var t = [], r = [], s = [], n = [], a, i, o, c, u;
  for (a = 0; a < 7; a++)
    i = ee([2e3, 1]).day(a), o = le(this.weekdaysMin(i, "")), c = le(this.weekdaysShort(i, "")), u = le(this.weekdays(i, "")), t.push(o), r.push(c), s.push(u), n.push(o), n.push(c), n.push(u);
  t.sort(e), r.sort(e), s.sort(e), n.sort(e), this._weekdaysRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function $n(e) {
  var t, r;
  pn(this, e), Fn(this, e);
  for (r in e)
    w(e, r) && (t = e[r], te(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Vt(e, t) {
  var r = X({}, e), s;
  for (s in t)
    w(t, s) && (Se(e[s]) && Se(t[s]) ? (r[s] = {}, X(r[s], e[s]), X(r[s], t[s])) : t[s] != null ? r[s] = t[s] : delete r[s]);
  for (s in e)
    w(e, s) && !w(t, s) && Se(e[s]) && (r[s] = X({}, r[s]));
  return r;
}
function or(e) {
  e != null && this.set(e);
}
var jt;
Object.keys ? jt = Object.keys : jt = function(e) {
  var t, r = [];
  for (t in e)
    w(e, t) && r.push(t);
  return r;
};
var Zn = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function qn(e, t, r) {
  var s = this._calendar[e] || this._calendar.sameElse;
  return te(s) ? s.call(t, r) : s;
}
var Bn = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Jn(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()], s = this._longDateFormatCache;
  return t || !r ? t : s && s[e] && s[e].formatUpper === r ? s[e].format : (t = r.match(Xt).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), s || (s = this._longDateFormatCache = {}), s[e] = {
    formatUpper: r,
    format: t
  }, t);
}
var Qn = "Invalid date";
function Kn() {
  return this._invalidDate;
}
var Xn = "%d", ea = /\d{1,2}/;
function ta(e) {
  return this._ordinal.replace("%d", e);
}
var ra = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Qr(e, t, r, s) {
  var n = this._relativeTime[r];
  return te(n) ? n(e, t, r, s) : n.replace(/%d/i, e);
}
function sa(e, t, r, s) {
  return this.postformat(
    Qr.call(
      this,
      e,
      t,
      r,
      s
    )
  );
}
function Kr(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return te(r) ? r(t) : r.replace(/%s/i, t);
}
function na(e, t) {
  return this.postformat(
    Kr.call(this, e, t)
  );
}
function aa(e, t, r, s, n, a, i) {
  var o;
  return e < 100 && e >= 0 ? (o = new Date(e + 400, t, r, s, n, a, i), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, t, r, s, n, a, i), o;
}
function Me(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function _t(e, t, r) {
  var s = 7 + t - r, n = (7 + Me(e, 0, s).getUTCDay() - t) % 7;
  return -n + s - 1;
}
function Xr(e, t, r, s, n) {
  var a = (7 + r - s) % 7, i = _t(e, s, n), o = 1 + 7 * (t - 1) + a + i, c, u;
  return o <= 0 ? (c = e - 1, u = ze(c) + o) : o > ze(e) ? (c = e + 1, u = o - ze(e)) : (c = e, u = o), {
    year: c,
    dayOfYear: u
  };
}
function es(e, t, r, s) {
  var n = _t(e, r, s), a = Math.floor((t - n - 1) / 7) + 1, i, o;
  return a < 1 ? (o = e - 1, i = a + ue(o, r, s)) : a > ue(e, r, s) ? (i = a - ue(e, r, s), o = e + 1) : (o = e, i = a), {
    week: i,
    year: o
  };
}
function lr(e, t, r) {
  return es(e.year(), e.dayOfYear(), t, r);
}
function xr(e, t, r, s, n) {
  var a = Math.round(
    (Me(e, t, r) - Me(e, 0, 1)) / 864e5
  ) + 1;
  return es(e, a, s, n);
}
function ue(e, t, r) {
  var s = _t(e, t, r), n = _t(e + 1, t, r);
  return (ze(e) - s + n) / 7;
}
m("w", ["ww", 2], "wo", "week");
m("W", ["WW", 2], "Wo", "isoWeek");
h("w", M, Ie);
h("ww", M, A);
h("W", M, Ie);
h("WW", M, A);
Ee(
  ["w", "ww", "W", "WW"],
  function(e, t, r, s) {
    t[s.substr(0, 1)] = _(e);
  }
);
function ia(e) {
  return lr(e, this._week.dow, this._week.doy).week;
}
var oa = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function la() {
  return this._week.dow;
}
function ua() {
  return this._week.doy;
}
function da(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function fa(e) {
  var t = lr(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
function ur() {
  return this.hours() % 12 || 12;
}
function ha() {
  return this.hours() || 24;
}
m("H", ["HH", 2], 0, "hour");
m("h", ["hh", 2], 0, ur);
m("k", ["kk", 2], 0, ha);
m("hmm", 0, 0, function() {
  return "" + ur.apply(this) + z(this.minutes(), 2);
});
m("hmmss", 0, 0, function() {
  return "" + ur.apply(this) + z(this.minutes(), 2) + z(this.seconds(), 2);
});
m("Hmm", 0, 0, function() {
  return "" + this.hours() + z(this.minutes(), 2);
});
m("Hmmss", 0, 0, function() {
  return "" + this.hours() + z(this.minutes(), 2) + z(this.seconds(), 2);
});
function ts(e, t) {
  m(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
ts("a", !0);
ts("A", !1);
function rs(e, t) {
  return t._meridiemParse;
}
h("a", rs);
h("A", rs);
h("H", M, sr);
h("h", M, Ie);
h("k", M, Ie);
h("HH", M, A);
h("hh", M, A);
h("kk", M, A);
h("hmm", Vr);
h("hmmss", tr);
h("Hmm", Vr);
h("Hmmss", tr);
S(["H", "HH"], T);
S(["k", "kk"], function(e, t, r) {
  var s = _(e);
  t[T] = s === 24 ? 0 : s;
});
S(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
S(["h", "hh"], function(e, t, r) {
  t[T] = _(e), y(r).bigHour = !0;
});
S("hmm", function(e, t, r) {
  var s = e.length - 2;
  t[T] = _(e.substr(0, s)), t[G] = _(e.substr(s)), y(r).bigHour = !0;
});
S("hmmss", function(e, t, r) {
  var s = e.length - 4, n = e.length - 2;
  t[T] = _(e.substr(0, s)), t[G] = _(e.substr(s, 2)), t[oe] = _(e.substr(n)), y(r).bigHour = !0;
});
S("Hmm", function(e, t, r) {
  var s = e.length - 2;
  t[T] = _(e.substr(0, s)), t[G] = _(e.substr(s));
});
S("Hmmss", function(e, t, r) {
  var s = e.length - 4, n = e.length - 2;
  t[T] = _(e.substr(0, s)), t[G] = _(e.substr(s, 2)), t[oe] = _(e.substr(n));
});
function ca(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var ma = /[ap]\.?m?\.?/i, ya = Le("Hours", !0);
function _a(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var ss = {
  calendar: Zn,
  longDateFormat: Bn,
  invalidDate: Qn,
  ordinal: Xn,
  dayOfMonthOrdinalParse: ea,
  relativeTime: ra,
  months: _n,
  monthsShort: zr,
  week: oa,
  weekdays: Pn,
  weekdaysMin: xn,
  weekdaysShort: Jr,
  meridiemParse: ma
}, k = {}, He = {}, Ze;
function wa(e, t) {
  var r, s = Math.min(e.length, t.length);
  for (r = 0; r < s; r += 1)
    if (e[r] !== t[r])
      return r;
  return s;
}
function Gt(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function ga(e) {
  for (var t = 0, r, s, n, a; t < e.length; ) {
    for (a = Gt(e[t]).split("-"), r = a.length, s = Gt(e[t + 1]), s = s ? s.split("-") : null; r > 0; ) {
      if (n = Yt(a.slice(0, r).join("-")), n)
        return n;
      if (s && s.length >= r && wa(a, s) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Ze;
}
function pa(e) {
  return typeof e == "string" && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(e);
}
function Yt(e) {
  var t = null, r, s;
  if (w(k, e))
    return k[e];
  if (s = Gt(e), w(k, s))
    return k[s];
  if (typeof module < "u" && module && module.exports && pa(s))
    try {
      t = Ze._abbr, r = require, r("./locale/" + s), ye(t);
    } catch {
      k[s] = null;
    }
  if (w(k, s))
    return k[s];
}
function ye(e, t) {
  var r;
  return e && (C(t) ? r = fe(e) : r = dr(e, t), r ? Ze = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Ze._abbr;
}
function dr(e, t) {
  if (t !== null) {
    var r, s = ss;
    if (t.abbr = e, k[e] != null)
      Lr(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), s = k[e]._config;
    else if (t.parentLocale != null)
      if (k[t.parentLocale] != null)
        s = k[t.parentLocale]._config;
      else if (r = Yt(t.parentLocale), r != null)
        s = r._config;
      else
        return He[t.parentLocale] || (He[t.parentLocale] = []), He[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return k[e] = new or(Vt(s, t)), He[e] && He[e].forEach(function(n) {
      dr(n.name, n.config);
    }), ye(e), k[e];
  } else
    return delete k[e], null;
}
function va(e, t) {
  var r, s = Yt(e), n = ss;
  return s != null && (e = s._abbr), t != null ? (k[e] != null && k[e].parentLocale != null ? k[e].set(Vt(k[e]._config, t)) : (s != null && (n = s._config), t = Vt(n, t), s == null && (t.abbr = e), r = new or(t), r.parentLocale = k[e], k[e] = r), ye(e)) : k[e] != null && (k[e].parentLocale != null ? (k[e] = k[e].parentLocale, e === ye() && ye(e)) : k[e] != null && delete k[e]), k[e];
}
function fe(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Ze;
  if (!J(e)) {
    if (t = Yt(e), t)
      return t;
    e = [e];
  }
  return ga(e);
}
function ka() {
  return jt(k);
}
function fr(e) {
  var t, r = e._a;
  return r && y(e).overflow === -2 && (t = r[E] < 0 || r[E] > 11 ? E : r[I] < 1 || r[I] > nr(r[b], r[E]) ? I : r[T] < 0 || r[T] > 24 || r[T] === 24 && (r[G] !== 0 || r[oe] !== 0 || r[ke] !== 0) ? T : r[G] < 0 || r[G] > 59 ? G : r[oe] < 0 || r[oe] > 59 ? oe : r[ke] < 0 || r[ke] > 999 ? ke : -1, y(e)._overflowDayOfYear && (t < b || t > I) && (t = I), y(e)._overflowWeeks && t === -1 && (t = dn), y(e)._overflowWeekday && t === -1 && (t = fn), y(e).overflow = t), e;
}
var Sa = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Ma = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Da = /Z|[+-]\d\d(?::?\d\d)?/, dt = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Et = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Oa = /^\/?Date\((-?\d+)/i, Ya = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, ba = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function ns(e) {
  var t, r, s = e._i, n = Sa.exec(s) || Ma.exec(s), a, i, o, c, u = dt.length, f = Et.length;
  if (n) {
    for (y(e).iso = !0, t = 0, r = u; t < r; t++)
      if (dt[t][1].exec(n[1])) {
        i = dt[t][0], a = dt[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (n[3]) {
      for (t = 0, r = f; t < r; t++)
        if (Et[t][1].exec(n[3])) {
          o = (n[2] || " ") + Et[t][0];
          break;
        }
      if (o == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && o != null) {
      e._isValid = !1;
      return;
    }
    if (n[4])
      if (Da.exec(n[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (o || "") + (c || ""), cr(e);
  } else
    e._isValid = !1;
}
function Ta(e, t, r, s, n, a) {
  var i = [
    Pa(e),
    zr.indexOf(t),
    parseInt(r, 10),
    parseInt(s, 10),
    parseInt(n, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function Pa(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function xa(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Wa(e, t, r) {
  if (e) {
    var s = Jr.indexOf(e), n = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (s !== n)
      return y(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function Na(e, t, r) {
  if (e)
    return ba[e];
  if (t)
    return 0;
  var s = parseInt(r, 10), n = s % 100, a = (s - n) / 100;
  return a * 60 + n;
}
function as(e) {
  var t = Ya.exec(xa(e._i)), r;
  if (t) {
    if (r = Ta(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Wa(t[1], r, e))
      return;
    e._a = r, e._tzm = Na(t[8], t[9], t[10]), e._d = Me.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), y(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Ra(e) {
  var t = Oa.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (ns(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (as(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : d.createFromInputFallback(e);
}
d.createFromInputFallback = $(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Ve(e, t, r) {
  return e ?? t ?? r;
}
function Wr(e, t, r) {
  var s = Object.prototype.hasOwnProperty.call(
    e,
    "_isDefaultDatePartsForWeek"
  ), n = e._isDefaultDatePartsForWeek;
  e._isDefaultDatePartsForWeek = !!r;
  try {
    return d._getDefaultDateParts(e, t, r);
  } finally {
    s ? e._isDefaultDatePartsForWeek = n : delete e._isDefaultDatePartsForWeek;
  }
}
function Fa(e) {
  var t = e._defaultDatePartsNow;
  return t ? (t.hasValue || (t.value = d.now(), t.hasValue = !0), t.value) : d.now();
}
function Ca(e, t, r) {
  var s = r || e._isDefaultDatePartsForWeek, n = s ? O(t) : new Date(t);
  return s ? [n.year(), n.month(), n.date()] : e._useUTC ? [
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate()
  ] : [n.getFullYear(), n.getMonth(), n.getDate()];
}
d._getDefaultDateParts = Ca;
function hr(e) {
  var t, r, s = [], n, a, i, o, c;
  if (!e._d) {
    for ((e._a[b] == null || e._a[E] == null || e._a[I] == null) && (n = Fa(e), a = Wr(e, n)), e._w && e._a[I] == null && e._a[E] == null && Ia(e, Wr(e, n, !0)), e._dayOfYear != null && (o = e._a[b] != null ? e._a[b] : a[b], (e._dayOfYear > ze(o) || e._dayOfYear === 0) && (y(e)._overflowDayOfYear = !0), r = Me(o, 0, e._dayOfYear), e._a[E] = r.getUTCMonth(), e._a[I] = r.getUTCDate()), c = e._a[b] == null || e._a[E] == null || e._a[I] == null, t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = s[t] = a[t];
    for (; t < 7; t++)
      e._a[t] = s[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[T] === 24 && e._a[G] === 0 && e._a[oe] === 0 && e._a[ke] === 0 && (e._nextDay = !0, e._a[T] = 0), e._d = (e._useUTC ? Me : aa).apply(
      null,
      s
    ), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[T] = 24), e._w && typeof e._w.d < "u" && !c && e._w.d !== i && (y(e).weekdayMismatch = !0);
  }
}
function Ia(e, t) {
  var r, s, n, a, i, o, c, u, f;
  r = e._w, r.GG != null || r.W != null || r.E != null ? (i = 1, o = 4, s = Ve(
    r.GG,
    e._a[b],
    xr(
      t[b],
      t[E],
      t[I],
      1,
      4
    ).year
  ), n = Ve(r.W, 1), a = Ve(r.E, 1), (a < 1 || a > 7) && (u = !0)) : (i = e._locale._week.dow, o = e._locale._week.doy, f = xr(
    t[b],
    t[E],
    t[I],
    i,
    o
  ), s = Ve(r.gg, e._a[b], f.year), n = Ve(r.w, f.week), r.d != null ? (a = r.d, (a < 0 || a > 6) && (u = !0)) : r.e != null ? (a = r.e + i, (r.e < 0 || r.e > 6) && (u = !0)) : a = i), n < 1 || n > ue(s, i, o) ? y(e)._overflowWeeks = !0 : u != null ? y(e)._overflowWeekday = !0 : (c = Xr(s, n, a, i, o), e._a[b] = c.year, e._dayOfYear = c.dayOfYear);
}
d.ISO_8601 = function() {
};
d.RFC_2822 = function() {
};
function cr(e) {
  if (e._f === d.ISO_8601) {
    ns(e);
    return;
  }
  if (e._f === d.RFC_2822) {
    as(e);
    return;
  }
  e._a = [], y(e).empty = !0;
  var t = "" + e._i, r, s, n, a, i, o = t.length, c = 0, u, f;
  for (n = Ar(e._f, e._locale).match(Xt) || [], f = n.length, r = 0; r < f; r++)
    a = n[r], s = (t.match(on(a, e)) || [])[0], s && (i = t.substr(0, t.indexOf(s)), i.length > 0 && y(e).unusedInput.push(i), t = t.slice(
      t.indexOf(s) + s.length
    ), c += s.length), Ne[a] ? (s ? y(e).empty = !1 : y(e).unusedTokens.push(a), un(a, s, e)) : e._strict && !s && y(e).unusedTokens.push(a);
  y(e).charsLeftOver = o - c, t.length > 0 && y(e).unusedInput.push(t), e._a[T] <= 12 && y(e).bigHour === !0 && e._a[T] > 0 && (y(e).bigHour = void 0), y(e).parsedDateParts = e._a.slice(0), y(e).meridiem = e._meridiem, e._a[T] = Ea(
    e._locale,
    e._a[T],
    e._meridiem
  ), u = y(e).era, u !== null && (e._a[b] = e._locale.erasConvertYear(u, e._a[b])), hr(e), fr(e);
}
function Ea(e, t, r) {
  var s;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (s = e.isPM(r), s && t < 12 && (t += 12), !s && t === 12 && (t = 0)), t);
}
function La(e) {
  var t, r, s, n, a, i, o = !1, c = {}, u = e._f.length;
  if (u === 0) {
    y(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (n = 0; n < u; n++)
    a = 0, i = !1, t = Qt({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._defaultDatePartsNow = c, t._f = e._f[n], cr(t), Jt(t) && (i = !0), a += y(t).charsLeftOver, a += y(t).unusedTokens.length * 10, y(t).score = a, o ? a < s && (s = a, r = t) : (s == null || a < s || i) && (s = a, r = t, i && (o = !0));
  X(e, r || t);
}
function Aa(e) {
  if (!e._d) {
    var t = Kt(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = Ir(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(s) {
        return s && parseInt(s, 10);
      }
    ), hr(e);
  }
}
function Ua(e) {
  var t = new Je(fr(is(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function is(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || fe(e._l), t === null || r === void 0 && t === "" ? Be({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), L(t) ? new Je(fr(t)) : (qe(t) ? e._d = t : J(r) ? La(e) : r ? cr(e) : Ha(e), Jt(e) || (e._d = null), e));
}
function Ha(e) {
  var t = e._i;
  C(t) ? e._d = new Date(d.now()) : qe(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Ra(e) : J(t) ? (e._a = Ir(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), hr(e)) : Se(t) ? Aa(e) : de(t) ? e._d = new Date(t) : d.createFromInputFallback(e);
}
function os(e, t, r, s, n) {
  var a = {};
  return (t === !0 || t === !1) && (s = t, t = void 0), (r === !0 || r === !1) && (s = r, r = void 0), (Se(e) && Bt(e) || J(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = n, a._l = r, a._i = e, a._f = t, a._strict = s, Ua(a);
}
function O(e, t, r, s) {
  return os(e, t, r, s, !1);
}
var Va = $(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = O.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Be();
  }
), ja = $(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = O.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Be();
  }
);
function ls(e, t) {
  var r, s;
  if (t.length === 1 && J(t[0]) && (t = t[0]), !t.length)
    return O();
  for (s = 0; s < t.length; ++s)
    if (L(t[s])) {
      r = t[s];
      break;
    }
  if (!r)
    return Be();
  for (++s; s < t.length; ++s)
    L(t[s]) && (!t[s].isValid() || t[s][e](r)) && (r = t[s]);
  return r;
}
function Ga() {
  var e = [].slice.call(arguments, 0);
  return ls("isBefore", e);
}
function za() {
  var e = [].slice.call(arguments, 0);
  return ls("isAfter", e);
}
var $a = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, je = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Za(e) {
  var t, r = !1, s, n = je.length;
  for (t in e)
    if (w(e, t) && !(Y.call(je, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (s = 0; s < n; ++s)
    if (e[je[s]]) {
      if (r)
        return !1;
      parseFloat(e[je[s]]) !== _(e[je[s]]) && (r = !0);
    }
  return !0;
}
function qa() {
  return this._isValid;
}
function Ba() {
  return Q(NaN);
}
function bt(e) {
  var t = Kt(e), r = t.year || 0, s = t.quarter || 0, n = t.month || 0, a = t.week || t.isoWeek || 0, i = t.day || 0, o = t.hour || 0, c = t.minute || 0, u = t.second || 0, f = t.millisecond || 0;
  this._isValid = Za(t), this._milliseconds = +f + u * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  o * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +n + s * 3 + r * 12, this._data = {}, this._locale = fe(), this._bubble();
}
function ht(e) {
  return e instanceof bt;
}
function zt(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Ja(e, t, r) {
  var s = Math.min(e.length, t.length), n = Math.abs(e.length - t.length), a = 0, i;
  for (i = 0; i < s; i++)
    _(e[i]) !== _(t[i]) && a++;
  return a + n;
}
function us(e, t) {
  m(e, 0, 0, function() {
    var r = this.utcOffset(), s = "+";
    return r < 0 && (r = -r, s = "-"), s + z(~~(r / 60), 2) + t + z(~~r % 60, 2);
  });
}
us("Z", ":");
us("ZZ", "");
h("Z", Dt);
h("ZZ", Dt);
S(["Z", "ZZ"], function(e, t, r) {
  var s = mr(Dt, e);
  r._useUTC = !0, r._tzm = s, s === null && (y(r).invalidOffset = e);
});
var Qa = /([\+\-]|\d\d)/gi;
function mr(e, t) {
  var r = (t || "").match(e), s, n, a;
  return r === null || (s = r[r.length - 1] || [], n = (s + "").match(Qa) || ["-", 0, 0], a = +(n[1] * 60) + _(n[2]), _(n[2]) > 59 || (n[0] === "+" ? a > 840 : a > 720)) ? null : a === 0 ? 0 : n[0] === "+" ? a : -a;
}
function yr(e, t) {
  var r, s;
  return t._isUTC ? (r = t.clone(), s = (L(e) || qe(e) ? e.valueOf() : O(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + s), d.updateOffset(r, !1), r) : O(e).local();
}
function $t(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
d.updateOffset = function() {
};
function Ka(e, t, r) {
  var s = this._offset || 0, n;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = mr(Dt, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (n = $t(this)), this._offset = e, this._isUTC = !0, n != null && this.add(n, "m"), s !== e && (!t || this._changeInProgress ? hs(
      this,
      Q(e - s, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, d.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? s : $t(this);
}
function Xa(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function ei(e) {
  return this.utcOffset(0, e);
}
function ti(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract($t(this), "m")), this;
}
function ri() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = mr(nn, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function si(e) {
  return this.isValid() ? (e = e ? O(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function ni() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function ai() {
  if (!C(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Qt(e, this), e = is(e), e._a ? (t = e._isUTC ? ee(e._a) : O(e._a), this._isDSTShifted = this.isValid() && Ja(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function ii() {
  return this.isValid() ? !this._isUTC : !1;
}
function oi() {
  return this.isValid() ? this._isUTC : !1;
}
function ds() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var li = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, ui = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Q(e, t) {
  var r = e, s = null, n, a, i;
  return ht(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : de(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (s = li.exec(e)) ? (n = s[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: _(s[I]) * n,
    h: _(s[T]) * n,
    m: _(s[G]) * n,
    s: _(s[oe]) * n,
    ms: _(zt(s[ke] * 1e3)) * n
    // the millisecond decimal point is included in the match
  }) : (s = ui.exec(e)) ? (n = s[1] === "-" ? -1 : 1, r = {
    y: ve(s[2], n),
    M: ve(s[3], n),
    w: ve(s[4], n),
    d: ve(s[5], n),
    h: ve(s[6], n),
    m: ve(s[7], n),
    s: ve(s[8], n)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (i = di(
    O(r.from),
    O(r.to)
  ), r = {}, r.ms = i.milliseconds, r.M = i.months), a = new bt(r), ht(e) && w(e, "_locale") && (a._locale = e._locale), ht(e) && w(e, "_isValid") && (a._isValid = e._isValid), a;
}
Q.fn = bt.prototype;
Q.invalid = Ba;
function ve(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function Nr(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function di(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = yr(t, e), e.isBefore(t) ? r = Nr(e, t) : (r = Nr(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function fs(e, t) {
  return function(r, s) {
    var n, a;
    return s !== null && !isNaN(+s) && (Lr(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = s, s = a), n = Q(r, s), hs(this, n, e), this;
  };
}
function hs(e, t, r, s) {
  var n = t._milliseconds, a = zt(t._days), i = zt(t._months);
  e.isValid() && (s = s ?? !0, i && Zr(e, $e(e, "Month") + i * r), a && Gr(e, "Date", $e(e, "Date") + a * r), n && e._d.setTime(e._d.valueOf() + n * r), s && d.updateOffset(e, a || i));
}
var fi = fs(1, "add"), hi = fs(-1, "subtract");
function cs(e) {
  return typeof e == "string" || e instanceof String;
}
function ci(e) {
  return L(e) || qe(e) || cs(e) || de(e) || yi(e) || mi(e) || e === null || e === void 0;
}
function mi(e) {
  var t = Se(e) && !Bt(e), r = !1, s = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], n, a, i = s.length;
  for (n = 0; n < i; n += 1)
    a = s[n], r = r || w(e, a);
  return t && r;
}
function yi(e) {
  var t = J(e), r = !1;
  return t && (r = e.filter(function(s) {
    return !de(s) && cs(e);
  }).length === 0), t && r;
}
function _i(e) {
  var t = Se(e) && !Bt(e), r = !1, s = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], n, a;
  for (n = 0; n < s.length; n += 1)
    a = s[n], r = r || w(e, a);
  return t && r;
}
function wi(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function gi(e, t) {
  arguments.length === 1 && (arguments[0] ? ci(arguments[0]) ? (e = arguments[0], t = void 0) : _i(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || O(), s = yr(r, this).startOf("day"), n = d.calendarFormat(this, s) || "sameElse", a = t && (te(t[n]) ? t[n].call(this, r) : t[n]);
  return this.format(
    a || this.localeData().calendar(n, this, O(r))
  );
}
function pi() {
  return new Je(this);
}
function vi(e, t) {
  var r = L(e) ? e : O(e);
  return this.isValid() && r.isValid() ? (t = Z(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function ki(e, t) {
  var r = L(e) ? e : O(e);
  return this.isValid() && r.isValid() ? (t = Z(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function Si(e, t, r, s) {
  var n = L(e) ? e : O(e), a = L(t) ? t : O(t);
  return this.isValid() && n.isValid() && a.isValid() ? (s = s || "()", (s[0] === "(" ? this.isAfter(n, r) : !this.isBefore(n, r)) && (s[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function Mi(e, t) {
  var r = L(e) ? e : O(e), s;
  return this.isValid() && r.isValid() ? (t = Z(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (s = r.valueOf(), this.clone().startOf(t).valueOf() <= s && s <= this.clone().endOf(t).valueOf())) : !1;
}
function Di(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Oi(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function Yi(e, t, r) {
  var s, n, a;
  if (!this.isValid())
    return NaN;
  if (s = yr(e, this), !s.isValid())
    return NaN;
  switch (n = (s.utcOffset() - this.utcOffset()) * 6e4, t = Z(t), t) {
    case "year":
      a = ct(this, s) / 12;
      break;
    case "month":
      a = ct(this, s);
      break;
    case "quarter":
      a = ct(this, s) / 3;
      break;
    case "second":
      a = (this - s) / 1e3;
      break;
    // 1000
    case "minute":
      a = (this - s) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      a = (this - s) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      a = (this - s - n) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      a = (this - s - n) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      a = this - s;
  }
  return r ? a : j(a);
}
function ct(e, t) {
  if (e.date() < t.date())
    return -ct(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), s = e.clone().add(r, "months"), n, a;
  return t - s < 0 ? (n = e.clone().add(r - 1, "months"), a = (t - s) / (s - n)) : (n = e.clone().add(r + 1, "months"), a = (t - s) / (n - s)), -(r + a) || 0;
}
d.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
d.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function bi() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Ti(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? ft(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : te(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", ft(r, "Z")) : ft(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Pi() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, s, n, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + s + n + a);
}
function xi(e) {
  e || (e = this.isUtc() ? d.defaultFormatUtc : d.defaultFormat);
  var t = ft(this, e);
  return this.localeData().postformat(t);
}
function Wi(e, t) {
  return this.isValid() && (L(e) && e.isValid() || O(e).isValid()) ? Q({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Ni(e) {
  return this.from(O(), e);
}
function Ri(e, t) {
  return this.isValid() && (L(e) && e.isValid() || O(e).isValid()) ? Q({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Fi(e) {
  return this.to(O(), e);
}
function ms(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = fe(e), t != null && (this._locale = t), this);
}
var ys = $(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function _s() {
  return this._locale;
}
var wt = 1e3, Re = 60 * wt, gt = 60 * Re, ws = (365 * 400 + 97) * 24 * gt;
function Fe(e, t) {
  return (e % t + t) % t;
}
function gs(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - ws : new Date(e, t, r).valueOf();
}
function ps(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - ws : Date.UTC(e, t, r);
}
function Ci(e) {
  var t, r;
  if (e = Z(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? ps : gs, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Fe(
        t + (this._isUTC ? 0 : this.utcOffset() * Re),
        gt
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Fe(t, Re);
      break;
    case "second":
      t = this._d.valueOf(), t -= Fe(t, wt);
      break;
  }
  return this._d.setTime(t), d.updateOffset(this, !0), this;
}
function Ii(e) {
  var t, r;
  if (e = Z(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? ps : gs, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += gt - Fe(
        t + (this._isUTC ? 0 : this.utcOffset() * Re),
        gt
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Re - Fe(t, Re) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += wt - Fe(t, wt) - 1;
      break;
  }
  return this._d.setTime(t), d.updateOffset(this, !0), this;
}
function Ei() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Li() {
  return Math.floor(this.valueOf() / 1e3);
}
function Ai() {
  return new Date(this.valueOf());
}
function Ui() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Hi() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Vi() {
  return this.isValid() ? this.toISOString() : null;
}
function ji() {
  return Jt(this);
}
function Gi() {
  return X({}, y(this));
}
function zi() {
  return y(this).overflow;
}
function $i() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
m("N", 0, 0, "eraAbbr");
m("NN", 0, 0, "eraAbbr");
m("NNN", 0, 0, "eraAbbr");
m("NNNN", 0, 0, "eraName");
m("NNNNN", 0, 0, "eraNarrow");
m("y", ["y", 1], "yo", "eraYear");
m("y", ["yy", 2], 0, "eraYear");
m("y", ["yyy", 3], 0, "eraYear");
m("y", ["yyyy", 4], 0, "eraYear");
h("N", _r);
h("NN", _r);
h("NNN", _r);
h("NNNN", so);
h("NNNNN", no);
S(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, s) {
    var n = r._locale.erasParse(e, s, r._strict);
    n ? y(r).era = n : y(r).invalidEra = e;
  }
);
h("y", Ce);
h("yy", Ce);
h("yyy", Ce);
h("yyyy", Ce);
h("yo", ao);
S(["y", "yy", "yyy", "yyyy"], b);
S(["yo"], function(e, t, r, s) {
  var n;
  r._locale._eraYearOrdinalRegex && (n = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[b] = r._locale.eraYearOrdinalParse(e, n) : t[b] = parseInt(e, 10);
});
function Zi(e, t) {
  var r, s, n, a = this._eras || fe("en")._eras;
  for (r = 0, s = a.length; r < s; ++r)
    switch (typeof a[r].since === "string" && (n = d(a[r].since).startOf("day"), a[r].since = n.valueOf()), typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        n = d(a[r].until).startOf("day").valueOf(), a[r].until = n.valueOf();
        break;
    }
  return a;
}
function qi(e, t, r) {
  var s, n, a = this.eras(), i, o, c;
  for (e = e.toUpperCase(), s = 0, n = a.length; s < n; ++s)
    if (i = a[s].name.toUpperCase(), o = a[s].abbr.toUpperCase(), c = a[s].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (o === e)
            return a[s];
          break;
        case "NNNN":
          if (i === e)
            return a[s];
          break;
        case "NNNNN":
          if (c === e)
            return a[s];
          break;
      }
    else if ([i, o, c].indexOf(e) >= 0)
      return a[s];
}
function Bi(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? d(e.since).year() : d(e.since).year() + (t - e.offset) * r;
}
function Ji() {
  var e, t, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return s[e].name;
  return "";
}
function Qi() {
  var e, t, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return s[e].narrow;
  return "";
}
function Ki() {
  var e, t, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return s[e].abbr;
  return "";
}
function Xi() {
  var e, t, r, s, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = n[e].since <= n[e].until ? 1 : -1, s = this.clone().startOf("day").valueOf(), n[e].since <= s && s <= n[e].until || n[e].until <= s && s <= n[e].since)
      return (this.year() - d(n[e].since).year()) * r + n[e].offset;
  return this.year();
}
function eo(e) {
  return w(this, "_erasNameRegex") || wr.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function to(e) {
  return w(this, "_erasAbbrRegex") || wr.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function ro(e) {
  return w(this, "_erasNarrowRegex") || wr.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function _r(e, t) {
  return t.erasAbbrRegex(e);
}
function so(e, t) {
  return t.erasNameRegex(e);
}
function no(e, t) {
  return t.erasNarrowRegex(e);
}
function ao(e, t) {
  return t._eraYearOrdinalRegex || Ce;
}
function wr() {
  var e = [], t = [], r = [], s = [], n, a, i, o, c, u = this.eras();
  for (n = 0, a = u.length; n < a; ++n)
    i = le(u[n].name), o = le(u[n].abbr), c = le(u[n].narrow), t.push(i), e.push(o), r.push(c), s.push(i), s.push(o), s.push(c);
  this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
m(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
m(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Tt(e, t) {
  m(0, [e, e.length], 0, t);
}
Tt("gggg", "weekYear");
Tt("ggggg", "weekYear");
Tt("GGGG", "isoWeekYear");
Tt("GGGGG", "isoWeekYear");
h("G", Mt);
h("g", Mt);
h("GG", M, A);
h("gg", M, A);
h("GGGG", rr, er);
h("gggg", rr, er);
h("GGGGG", St, vt);
h("ggggg", St, vt);
Ee(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, s) {
    t[s.substr(0, 2)] = _(e);
  }
);
Ee(["gg", "GG"], function(e, t, r, s) {
  t[s] = d.parseTwoDigitYear(e);
});
function io(e) {
  return vs.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function oo(e) {
  return vs.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function lo() {
  return ue(this.year(), 1, 4);
}
function uo() {
  return ue(this.isoWeekYear(), 1, 4);
}
function fo() {
  var e = this.localeData()._week;
  return ue(this.year(), e.dow, e.doy);
}
function ho() {
  var e = this.localeData()._week;
  return ue(this.weekYear(), e.dow, e.doy);
}
function vs(e, t, r, s, n) {
  var a;
  return e == null ? lr(this, s, n).year : (a = ue(e, s, n), t > a && (t = a), co.call(this, e, t, r, s, n));
}
function co(e, t, r, s, n) {
  var a = Xr(e, t, r, s, n), i = Me(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
m("Q", 0, "Qo", "quarter");
h("Q", Ur);
S("Q", function(e, t) {
  t[E] = (_(e) - 1) * 3;
});
function mo(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
m("D", ["DD", 2], "Do", "date");
h("D", M, Ie);
h("DD", M, A);
h("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
S(["D", "DD"], I);
S("Do", function(e, t) {
  t[I] = _(e.match(M)[0]);
});
var ks = Le("Date", !0);
m("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
h("DDD", kt);
h("DDDD", Hr);
S(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = _(e);
});
function yo(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
m("m", ["mm", 2], 0, "minute");
h("m", M, sr);
h("mm", M, A);
S(["m", "mm"], G);
var _o = Le("Minutes", !1);
m("s", ["ss", 2], 0, "second");
h("s", M, sr);
h("ss", M, A);
S(["s", "ss"], oe);
var wo = Le("Seconds", !1);
m("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
m(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
m(0, ["SSS", 3], 0, "millisecond");
m(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
m(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
m(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
m(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
m(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
m(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
h("S", kt, Ur);
h("SS", kt, A);
h("SSS", kt, Hr);
var me, Ss;
for (me = "SSSS"; me.length <= 9; me += "S")
  h(me, Ce);
function go(e, t) {
  t[ke] = _(("0." + e) * 1e3);
}
for (me = "S"; me.length <= 9; me += "S")
  S(me, go);
Ss = Le("Milliseconds", !1);
m("z", 0, 0, "zoneAbbr");
m("zz", 0, 0, "zoneName");
function po() {
  return this._isUTC ? "UTC" : "";
}
function vo() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var l = Je.prototype;
l.add = fi;
l.calendar = gi;
l.clone = pi;
l.diff = Yi;
l.endOf = Ii;
l.format = xi;
l.from = Wi;
l.fromNow = Ni;
l.to = Ri;
l.toNow = Fi;
l.get = cn;
l.invalidAt = zi;
l.isAfter = vi;
l.isBefore = ki;
l.isBetween = Si;
l.isSame = Mi;
l.isSameOrAfter = Di;
l.isSameOrBefore = Oi;
l.isValid = ji;
l.lang = ys;
l.locale = ms;
l.localeData = _s;
l.max = ja;
l.min = Va;
l.parsingFlags = Gi;
l.set = mn;
l.startOf = Ci;
l.subtract = hi;
l.toArray = Ui;
l.toObject = Hi;
l.toDate = Ai;
l.toISOString = Ti;
l.inspect = Pi;
typeof Symbol < "u" && Symbol.for != null && (l[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
l.toJSON = Vi;
l.toString = bi;
l.unix = Li;
l.valueOf = Ei;
l.creationData = $i;
l.eraName = Ji;
l.eraNarrow = Qi;
l.eraAbbr = Ki;
l.eraYear = Xi;
l.year = jr;
l.isLeapYear = hn;
l.weekYear = io;
l.isoWeekYear = oo;
l.quarter = l.quarters = mo;
l.month = qr;
l.daysInMonth = Dn;
l.week = l.weeks = da;
l.isoWeek = l.isoWeeks = fa;
l.weeksInYear = fo;
l.weeksInWeekYear = ho;
l.isoWeeksInYear = lo;
l.isoWeeksInISOWeekYear = uo;
l.date = ks;
l.day = l.days = Un;
l.weekday = Hn;
l.isoWeekday = Vn;
l.dayOfYear = yo;
l.hour = l.hours = ya;
l.minute = l.minutes = _o;
l.second = l.seconds = wo;
l.millisecond = l.milliseconds = Ss;
l.utcOffset = Ka;
l.utc = ei;
l.local = ti;
l.parseZone = ri;
l.hasAlignedHourOffset = si;
l.isDST = ni;
l.isLocal = ii;
l.isUtcOffset = oi;
l.isUtc = ds;
l.isUTC = ds;
l.zoneAbbr = po;
l.zoneName = vo;
l.dates = $(
  "dates accessor is deprecated. Use date instead.",
  ks
);
l.months = $(
  "months accessor is deprecated. Use month instead",
  qr
);
l.years = $(
  "years accessor is deprecated. Use year instead",
  jr
);
l.zone = $(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Xa
);
l.isDSTShifted = $(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  ai
);
function ko(e) {
  return O(e * 1e3);
}
function So() {
  return O.apply(null, arguments).parseZone();
}
function Ms(e) {
  return e;
}
var p = or.prototype;
p.calendar = qn;
p.longDateFormat = Jn;
p.invalidDate = Kn;
p.ordinal = ta;
p.preparse = Ms;
p.postformat = Ms;
p.relativeTime = sa;
p.pastFuture = na;
p.set = $n;
p.eras = Zi;
p.erasParse = qi;
p.erasConvertYear = Bi;
p.erasAbbrRegex = to;
p.erasNameRegex = eo;
p.erasNarrowRegex = ro;
p.months = vn;
p.monthsShort = kn;
p.monthsParse = Mn;
p.monthsRegex = Yn;
p.monthsShortRegex = On;
p.week = ia;
p.firstDayOfYear = ua;
p.firstDayOfWeek = la;
p.weekdays = Cn;
p.weekdaysMin = En;
p.weekdaysShort = In;
p.weekdaysParse = An;
p.weekdaysRegex = jn;
p.weekdaysShortRegex = Gn;
p.weekdaysMinRegex = zn;
p.isPM = ca;
p.meridiem = _a;
function pt(e, t, r, s) {
  var n = fe(), a = ee().set(s, t);
  return n[r](a, e);
}
function Ds(e, t, r) {
  if (de(e) && (t = e, e = void 0), e = e || "", t != null)
    return pt(e, t, r, "month");
  var s, n = [];
  for (s = 0; s < 12; s++)
    n[s] = pt(e, s, r, "month");
  return n;
}
function gr(e, t, r, s) {
  typeof e == "boolean" ? (de(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, de(t) && (r = t, t = void 0), t = t || "");
  var n = fe(), a = e ? n._week.dow : 0, i, o = [];
  if (r != null)
    return pt(t, (r + a) % 7, s, "day");
  for (i = 0; i < 7; i++)
    o[i] = pt(t, (i + a) % 7, s, "day");
  return o;
}
function Mo(e, t) {
  return Ds(e, t, "months");
}
function Do(e, t) {
  return Ds(e, t, "monthsShort");
}
function Oo(e, t, r) {
  return gr(e, t, r, "weekdays");
}
function Yo(e, t, r) {
  return gr(e, t, r, "weekdaysShort");
}
function bo(e, t, r) {
  return gr(e, t, r, "weekdaysMin");
}
ye("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = _(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
d.lang = $(
  "moment.lang is deprecated. Use moment.locale instead.",
  ye
);
d.langData = $(
  "moment.langData is deprecated. Use moment.localeData instead.",
  fe
);
var ae = Math.abs;
function To() {
  var e = this._data;
  return this._milliseconds = ae(this._milliseconds), this._days = ae(this._days), this._months = ae(this._months), e.milliseconds = ae(e.milliseconds), e.seconds = ae(e.seconds), e.minutes = ae(e.minutes), e.hours = ae(e.hours), e.months = ae(e.months), e.years = ae(e.years), this;
}
function Os(e, t, r, s) {
  var n = Q(t, r);
  return e._milliseconds += s * n._milliseconds, e._days += s * n._days, e._months += s * n._months, e._bubble();
}
function Po(e, t) {
  return Os(this, e, t, 1);
}
function xo(e, t) {
  return Os(this, e, t, -1);
}
function Rr(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Wo() {
  var e = this._milliseconds, t = this._days, r = this._months, s = this._data, n, a, i, o, c;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Rr(Zt(r) + t) * 864e5, t = 0, r = 0), s.milliseconds = e % 1e3, n = j(e / 1e3), s.seconds = n % 60, a = j(n / 60), s.minutes = a % 60, i = j(a / 60), s.hours = i % 24, t += j(i / 24), c = j(Ys(t)), r += c, t -= Rr(Zt(c)), o = j(r / 12), r %= 12, s.days = t, s.months = r, s.years = o, this;
}
function Ys(e) {
  return e * 4800 / 146097;
}
function Zt(e) {
  return e * 146097 / 4800;
}
function No(e) {
  if (!this.isValid())
    return NaN;
  var t, r, s = this._milliseconds;
  if (e = Z(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + s / 864e5, r = this._months + Ys(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Zt(this._months)), e) {
      case "week":
        return t / 7 + s / 6048e5;
      case "day":
        return t + s / 864e5;
      case "hour":
        return t * 24 + s / 36e5;
      case "minute":
        return t * 1440 + s / 6e4;
      case "second":
        return t * 86400 + s / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + s;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function he(e) {
  return function() {
    return this.as(e);
  };
}
var bs = he("ms"), Ro = he("s"), Fo = he("m"), Co = he("h"), Io = he("d"), Eo = he("w"), Lo = he("M"), Ao = he("Q"), Uo = he("y"), Ho = bs;
function Vo() {
  return Q(this);
}
function jo(e) {
  return e = Z(e), this.isValid() ? this[e + "s"]() : NaN;
}
function De(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Go = De("milliseconds"), zo = De("seconds"), $o = De("minutes"), Zo = De("hours"), qo = De("days"), Bo = De("months"), Jo = De("years");
function Qo() {
  return j(this.days() / 7);
}
var ie = Math.round, xe = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Ko(e, t, r, s, n) {
  return Qr.call(
    n,
    t || 1,
    !!r,
    e,
    s
  );
}
function Xo(e, t, r, s) {
  var n = Q(e).abs(), a = ie(n.as("s")), i = ie(n.as("m")), o = ie(n.as("h")), c = ie(n.as("d")), u = ie(n.as("M")), f = ie(n.as("w")), D = ie(n.as("y")), v = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || i <= 1 && ["m"] || i < r.m && ["mm", i] || o <= 1 && ["h"] || o < r.h && ["hh", o] || c <= 1 && ["d"] || c < r.d && ["dd", c];
  return r.w != null && (v = v || f <= 1 && ["w"] || f < r.w && ["ww", f]), v = v || u <= 1 && ["M"] || u < r.M && ["MM", u] || D <= 1 && ["y"] || ["yy", D], v[2] = t, v[3] = +e > 0, v[4] = s, Ko.apply(null, v);
}
function el(e) {
  return e === void 0 ? ie : typeof e == "function" ? (ie = e, !0) : !1;
}
function tl(e, t) {
  return xe[e] === void 0 ? !1 : t === void 0 ? xe[e] : (xe[e] = t, e === "s" && (xe.ss = t - 1), !0);
}
function rl(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, s = xe, n, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (s = X(X({}, xe), t || {}), t.s != null && t.ss == null && (s.ss = t.s - 1)), n = this.localeData(), a = Xo(this, !r, s, n), r && (a = Kr.call(n, +this, a)), n.postformat(a);
}
var Lt = Math.abs;
function Pe(e) {
  return (e > 0) - (e < 0) || +e;
}
function Pt() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Lt(this._milliseconds) / 1e3, t = Lt(this._days), r = Lt(this._months), s, n, a, i, o = this.asSeconds(), c, u, f, D;
  return o ? (s = j(e / 60), n = j(s / 60), e %= 60, s %= 60, a = j(r / 12), r %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = o < 0 ? "-" : "", u = Pe(this._months) !== Pe(o) ? "-" : "", f = Pe(this._days) !== Pe(o) ? "-" : "", D = Pe(this._milliseconds) !== Pe(o) ? "-" : "", c + "P" + (a ? u + a + "Y" : "") + (r ? u + r + "M" : "") + (t ? f + t + "D" : "") + (n || s || e ? "T" : "") + (n ? D + n + "H" : "") + (s ? D + s + "M" : "") + (e ? D + i + "S" : "")) : "P0D";
}
var g = bt.prototype;
g.isValid = qa;
g.abs = To;
g.add = Po;
g.subtract = xo;
g.as = No;
g.asMilliseconds = bs;
g.asSeconds = Ro;
g.asMinutes = Fo;
g.asHours = Co;
g.asDays = Io;
g.asWeeks = Eo;
g.asMonths = Lo;
g.asQuarters = Ao;
g.asYears = Uo;
g.valueOf = Ho;
g._bubble = Wo;
g.clone = Vo;
g.get = jo;
g.milliseconds = Go;
g.seconds = zo;
g.minutes = $o;
g.hours = Zo;
g.days = qo;
g.weeks = Qo;
g.months = Bo;
g.years = Jo;
g.humanize = rl;
g.toISOString = Pt;
g.toString = Pt;
g.toJSON = Pt;
g.locale = ms;
g.localeData = _s;
g.toIsoString = $(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Pt
);
g.lang = ys;
m("X", 0, 0, "unix");
m("x", 0, 0, "valueOf");
h("x", Mt);
h("X", an);
S("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
S("x", function(e, t, r) {
  r._d = new Date(_(e));
});
d.version = "2.31.0";
Ks(O);
d.fn = l;
d.min = Ga;
d.max = za;
d.now = $a;
d.utc = ee;
d.unix = ko;
d.months = Mo;
d.isDate = qe;
d.locale = ye;
d.invalid = Be;
d.duration = Q;
d.isMoment = L;
d.weekdays = Oo;
d.parseZone = So;
d.localeData = fe;
d.isDuration = ht;
d.monthsShort = Do;
d.weekdaysMin = bo;
d.defineLocale = dr;
d.updateLocale = va;
d.locales = ka;
d.weekdaysShort = Yo;
d.normalizeUnits = Z;
d.relativeTimeRounding = el;
d.relativeTimeThreshold = tl;
d.calendarFormat = wi;
d.prototype = l;
d.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const sl = Ns(void 0), ml = (e) => {
  const t = Ws(50), {
    children: r,
    state: s,
    initialMessages: n,
    adapter: a,
    events: i,
    storageKey: o,
    onFeedback: c
  } = e;
  let u;
  t[0] !== n ? (u = n ?? [], t[0] = n, t[1] = u) : u = t[1];
  const [f, D] = ne.useState(u), [v, U] = ne.useState(!1), [R, _e] = ne.useState(), [Oe, Ke] = ne.useState(s.maximize ?? !0), [Ye, we] = ne.useState(""), be = ne.useRef(null), x = Ls(), H = As();
  let ge;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ge = (P) => {
    U(!0);
    const B = {
      id: `message-${At(14)}`,
      timestamp: d().unix(),
      message: P,
      role: "user",
      type: "text"
    };
    D((V) => [...V, B]);
  }, t[2] = ge) : ge = t[2];
  const re = ge;
  let pe;
  t[3] !== f || t[4] !== o ? (pe = () => {
    o && f.length > 0 && sessionStorage.setItem(o, JSON.stringify(f)), be.current && be.current.focus();
  }, t[3] = f, t[4] = o, t[5] = pe) : pe = t[5];
  let q;
  t[6] !== f.length || t[7] !== o ? (q = [f.length, o], t[6] = f.length, t[7] = o, t[8] = q) : q = t[8], ne.useEffect(pe, q);
  let W;
  t[9] !== f || t[10] !== c || t[11] !== o ? (W = (P) => {
    const F = f.find((N) => N.id === P);
    if (!F)
      return;
    const B = F.feedback === 1 ? 0 : 1, V = f.map((N) => N.id === P ? {
      ...N,
      feedback: B
    } : N);
    D(V), c?.(P, F.message.toString(), B), o && V.length > 0 && sessionStorage.setItem(o, JSON.stringify(V));
  }, t[9] = f, t[10] = c, t[11] = o, t[12] = W) : W = t[12];
  const se = W;
  let Xe;
  t[13] !== f || t[14] !== c || t[15] !== o ? (Xe = (P) => {
    const F = f.find((N) => N.id === P);
    if (!F)
      return;
    const B = F.feedback === -1 ? 0 : -1, V = f.map((N) => N.id === P ? {
      ...N,
      feedback: B
    } : N);
    D(V), c?.(P, F.message.toString(), B), o && V.length > 0 && sessionStorage.setItem(o, JSON.stringify(V));
  }, t[13] = f, t[14] = c, t[15] = o, t[16] = Xe) : Xe = t[16];
  const xt = Xe;
  let et;
  t[17] !== H ? (et = (P, F, B, V) => {
    const N = B === void 0 ? "assistant" : B;
    if (!F)
      return;
    const Ae = {
      id: P,
      timestamp: d().unix(),
      message: F,
      role: N,
      agent: V,
      type: "text"
    };
    return D((Ue) => [...Ue, Ae]), H.speak(F), U(!1), Ae;
  }, t[17] = H, t[18] = et) : et = t[18];
  const ce = et;
  let tt;
  t[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (tt = (P) => {
    Ke(P);
  }, t[19] = tt) : tt = t[19];
  const Ts = tt;
  let rt;
  t[20] !== s ? (rt = () => {
    alert("Close"), s.onClose?.();
  }, t[20] = s, t[21] = rt) : rt = t[21];
  const Wt = rt;
  let st, nt;
  t[22] !== x.transcript || t[23] !== s.sendOnSpeech ? (st = () => {
    x.transcript && (s.sendOnSpeech ? re(x.transcript) : we(x.transcript));
  }, nt = [x.transcript, s.sendOnSpeech, re], t[22] = x.transcript, t[23] = s.sendOnSpeech, t[24] = st, t[25] = nt) : (st = t[24], nt = t[25]), ne.useEffect(st, nt);
  let at;
  t[26] !== a || t[27] !== f || t[28] !== i || t[29] !== v || t[30] !== ce ? (at = () => {
    const P = f[f.length - 1], F = P?.role === "user";
    v && F && async function() {
      const N = document.querySelector(".chatbot-body"), Ae = document.querySelector("#streaming > .message-wrapper > .message"), Ue = `message-${At(14)}`;
      let Nt = "";
      const Ps = {
        next: (K, pr) => {
          if (pr && _e(pr), Nt = Nt + K, Ae) {
            const xs = /* @__PURE__ */ vr(Fs, { className: "message assistant", remarkPlugins: [Cs], rehypePlugins: [Is], children: Nt });
            Ae.innerHTML = Es(xs), N?.scrollTo(0, N.scrollHeight);
          }
        },
        complete: () => {
          U(!1), _e(void 0);
        },
        error: (K) => {
          console.error(K), ce(Ue, K, "system");
        },
        system: (K) => {
          console.log("System: ", K), ce(Ue, K, "system");
        },
        history: f
      }, lt = await a(P.message, Ps, {
        history: f
      });
      if (i?.onMessageSent?.(P.message), lt) {
        const K = ce(lt.messageId ?? Ue, lt.message, "assistant", lt.sender);
        K && i?.onMessageReceived?.(K);
      }
    }();
  }, t[26] = a, t[27] = f, t[28] = i, t[29] = v, t[30] = ce, t[31] = at) : at = t[31];
  let it;
  t[32] !== i || t[33] !== v ? (it = [i, v], t[32] = i, t[33] = v, t[34] = it) : it = t[34], ne.useEffect(at, it);
  let Te;
  t[35] !== R || t[36] !== f || t[37] !== xt || t[38] !== v || t[39] !== se || t[40] !== Oe || t[41] !== Wt || t[42] !== Ye || t[43] !== ce || t[44] !== x || t[45] !== H ? (Te = {
    conversations: f,
    send: re,
    receive: ce,
    isProcessing: v,
    agent: R,
    like: se,
    dislike: xt,
    prompt: Ye,
    setPrompt: we,
    maximize: Oe,
    onSizeChange: Ts,
    onClose: Wt,
    inputRef: be,
    speech: x,
    transcription: H
  }, t[35] = R, t[36] = f, t[37] = xt, t[38] = v, t[39] = se, t[40] = Oe, t[41] = Wt, t[42] = Ye, t[43] = ce, t[44] = x, t[45] = H, t[46] = Te) : Te = t[46];
  let ot;
  return t[47] !== r || t[48] !== Te ? (ot = /* @__PURE__ */ vr(sl.Provider, { value: Te, children: r }), t[47] = r, t[48] = Te, t[49] = ot) : ot = t[49], ot;
};
export {
  sl as C,
  ml as a,
  d as h
};
